import { observer } from "mobx-react";
import * as React from "react";
import styled from "styled-components";

import Button from "@client/components/ui/Button";
import TextInput from "@client/components/ui/TextInput";
import Style from "@client/utils/Style";

import errorIcon from "./images/error.svg";

const Wrapper = styled.div``;
const LoginForm = styled.form`
  padding: 16px;
  background: rgba(218, 205, 234, 0.65);
  border-radius: 4px;
  margin-top: 32px;
`;
const TextInputs = styled.div``;
const TextInputWrapper = styled.div`
  margin-top: 16px;
  &:first-child {
    margin-top: 0;
  }
`;
const TextInputLabel = styled.div`
  font-size: 10px;
  font-weight: ${Style.fontWeights.medium};
  color: white;
  text-transform: uppercase;
`;
const LoginError = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 4px;
  margin-bottom: 16px;
`;
const LoginErrorIcon = styled.div`
  width: 26px;
  height: 26px;
  background-image: url("${errorIcon}");
`;
const LoginErrorText = styled.div`
  color: white;
  font-size: 12px;
  margin-top: 4px;
  width: ${Style.inputSizes.regular.width}px;
  text-align: center;
`;

type State = {
  username: string;
  password: string;
  errorMessage: string;
};

type Props = {
  onSubmit: (username: string, password: string) => void;
  disabled: boolean;
  errorMessage: string;
};

@observer
class LoginPage extends React.Component<Props, State> {
  state = {
    username: "",
    password: "",
    errorMessage: "",
  };

  UNSAFE_componentWillReceiveProps(newProps: Props) {
    if (newProps.errorMessage !== this.props.errorMessage) {
      this.setState({ errorMessage: newProps.errorMessage });
    }
  }

  handleSubmit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();
    if (this.props.disabled) {
      return;
    }

    this.setState({ errorMessage: "" });

    if (!this.state.username || !this.state.password) {
      this.setState({ errorMessage: "Please fill the username and password" });
    } else {
      this.props.onSubmit(this.state.username, this.state.password);
    }
  }

  renderErrorMessage() {
    if (!this.state.errorMessage) {
      return null;
    }

    return (
      <LoginError>
        <LoginErrorIcon />
        <LoginErrorText>{this.state.errorMessage}</LoginErrorText>
      </LoginError>
    );
  }

  render() {
    return (
      <Wrapper>
        <LoginForm
          onSubmit={e => {
            this.handleSubmit(e);
          }}
        >
          {this.renderErrorMessage()}
          <TextInputs>
            <TextInputWrapper>
              <TextInputLabel>Email</TextInputLabel>
              <TextInput
                name="username"
                value={this.state.username}
                disabled={this.props.disabled}
                onChange={username => {
                  this.setState({ username });
                }}
              />
            </TextInputWrapper>
            <TextInputWrapper>
              <TextInputLabel>Password</TextInputLabel>
              <TextInput
                name="password"
                value={this.state.password}
                disabled={this.props.disabled}
                onChange={password => {
                  this.setState({ password });
                }}
                type="password"
              />
            </TextInputWrapper>
          </TextInputs>
          <Button
            style={{ marginTop: "32px" }}
            disabled={this.props.disabled}
            type="submit"
          >
            Login
          </Button>
        </LoginForm>
      </Wrapper>
    );
  }
}

export default LoginPage;
